// extracted by mini-css-extract-plugin
export const container = "snackbar-module--container--3Ck4_";
export const hasItems = "snackbar-module--hasItems--1CIdA";
export const visible = "snackbar-module--visible--3c1Ij";
export const main = "snackbar-module--main--3zyGv";
export const alert = "snackbar-module--alert--bQZOK";
export const success = "snackbar-module--success--2ddS6";